const messages = {
  actionCloseText: 'Click here to expand filter',
}

export default messages
